module.exports = __webpack_public_path__ + "pizza-on-the-road.png?7fc7ad49d99fccfabeec0dffef5f7f70";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/pizza-on-the-road.png
// module id = 128
// module chunks = 0